
export default {

  APP_IS_READY: 'APP_IS_READY',

  STORE_ITEM_CREATE: 'STORE_ITEM_CREATE',
  STORE_ITEM_UPDATE: 'STORE_ITEM_UPDATE',
  STORE_ITEM_REPLACE: 'STORE_ITEM_REPLACE',
  STORE_ITEM_REMOVE: 'STORE_ITEM_REMOVE',
  STORE_RESET_COLLECTION: 'STORE_RESET_COLLECTION',
  STORE_BULK_INSERT_DATA: 'STORE_BULK_INSERT_DATA',
  LOG_IN_USER: 'LOG_IN_USER',
  MODAL_PAYLOAD_SET_COMMIT: 'MODAL_PAYLOAD_SET_COMMIT'

}



// WEBPACK FOOTER //
// ./src/store/actions.js